import request from '@/services/api';

export function login(query) {
    return request({
        url: '/auth/login',
        method: 'post',
        data: query
    })
}

// 新增：获取用户信息
export function getUserInfo(query) {
    return request({
        url: '/auth/user',
        method: 'post',
        data: query
    })
}

// 新增：退出登录
export function logout(query) {
    return request({
        url: '/auth/logout',
        method: 'post',
        data: query
    })
}

// 新增：修改语言设置
export function APIChangeLanguage(query) {
    return request({
        url: '/auth/changeLanguage',
        method: 'get',
        data: query
    })
}

// 新增：获取验证码
export function getCaptcha() {
    return request({
        url: '/auth/code',
        method: 'post',

    })
}
//发送验证码
export function apiSendCaptcha(query) {
    return request({
        url: '/auth/emailCode',
        method: 'post',
        data: query
    })
}

// 新增：注册用户
export function register(query) {
    return request({
        url: '/auth/registerNormalUser',
        method: 'put',
        data: query
    })
}